export const PRODUCTION = {
  cms: {
    default: 'delivery-frontend-cms.taxi.yandex.net',
    authorized: 'delivery-frontend-cms.taxi.yandex-team.ru',
  },
  'logistics-frontend': {
    default: 'logistics-frontend.taxi.yandex.net',
    authorized: 'dostavka.yandex.ru',
  },
  'static-com': {
    default: 'static-com.taxi.yandex.net',
    authorized: 'delivery.yandex.com',
    by: 'delivery.yandex.by',
    kg: 'delivery.yandex.kg',
    kz: 'delivery.yandex.kz',
    uz: 'delivery.yandex.uz',
  },
  'static-ru': {
    default: 'frontend-static-yango.taxi.dev.yandex.net',
    draft_mode: 'static-ru-inner.taxi.yandex.ru',
  },
  'static-yango': {
    default: 'static-yango.taxi.yandex.net',
    authorized: 'delivery.yango.com',
  },
} as const
